// extracted by mini-css-extract-plugin
module.exports = {"footer":"ClientFinantial_footer__30pxW","button":"ClientFinantial_button__2M476"};